export const EVENT_DASHBOARD_EVENTS = {
  DASHBOARD_LOADED: 'dashboard_loaded',
  ADVANCED_SETTINGS_TOGGLED: 'advanced_settings_toggled',
  EVENT_URL_COPIED: 'event_url_copied',
  PREVIEW_CLICKED: 'preview_clicked',
  TASK_CARD_CLICKED: 'task_card_clicked',
  TEMPLATE_FEEDBACK: 'template_feedback',
};
